(function() {
  const BRIDGE_VERSION = 'v12.31.14 (B2B Forms Active)';
  console.log(`%c[CASULO BRIDGE ${BRIDGE_VERSION}] 🦾 Cérebro de Fluxos Ativo...`, 'color: #fff; background: #2e7d32; font-weight: bold; padding: 5px; border-radius: 3px;');
  
  if (window.Shopify && window.Shopify.customer) {
    console.log('%c[CASULO DEBUG] Tags detectadas via JS:', 'background: #6a1b9a; color: #fff; padding: 2px 5px;', window.__casulo_customer_tags || 'Tags não injetadas ainda');
    
  }

  /**
   * 0. SISTEMA DE SEQUESTRO DE LINK (PURE SNATCHER)
   */
  (function captureHijack() {
      const originalCreate = URL.createObjectURL;
      window.URL.createObjectURL = function(blob) {
          const url = originalCreate.apply(this, arguments);
          if (blob instanceof Blob && blob.type && blob.type.startsWith('image/')) {
              window.__casulo_intercepted_blob = blob;
              window.__casulo_intercepted_url = url;
          }
          return url;
      };

      const originalClick = HTMLAnchorElement.prototype.click;
      HTMLAnchorElement.prototype.click = function() {
          if (window.__casulo_snatching && (this.href.startsWith('blob:') || this.href.startsWith('data:image'))) {
              window.__casulo_caught_url = this.href;
              return; 
          }
          return originalClick.apply(this, arguments);
      };

      const originalOpen = window.open;
      window.open = function(url) {
          if (window.__casulo_snatching && url && (url.startsWith('blob:') || url.startsWith('data:image'))) {
              window.__casulo_caught_url = url.split('?')[0]; 
              return null;
          }
          return originalOpen.apply(this, arguments);
      };
  })();

  const findDeep = (selector, root = document) => {
    const el = root.querySelector(selector);
    if (el) return el;
    const all = root.querySelectorAll('*');
    for (const node of all) {
      if (node.shadowRoot) {
        const found = findDeep(selector, node.shadowRoot);
        if (found) return found;
      }
    }
    return null;
  };

  const getShopifyCustomerId = () => {
    return window.__casulo_customer_id || 
           (window.Shopify && window.Shopify.customer ? window.Shopify.customer.id : null) || 
           (window.__st && window.__st.cid ? window.__st.cid : null);
  };

  const getShopifyProductId = () => {
    return (window.ShopifyAnalytics?.meta?.product?.id) || (window.__st?.rid) || null;
  };

  const getBrowserId = () => {
    let bid = localStorage.getItem('__casulo_browser_id');
    if (!bid) {
      bid = 'bid_' + Math.random().toString(36).substring(2, 11) + Date.now();
      localStorage.setItem('__casulo_browser_id', bid);
    }
    return bid;
  };

  /**
   * 1. CAPTURA DE LINK ORIGINAL
   */
  const capturarNativeAngle3D = async (delay = 200) => {
      window.__casulo_snatching = true;
      window.__casulo_caught_url = null;
      window.__casulo_intercepted_blob = null;
      await new Promise(r => setTimeout(r, delay));
      const btnNative = findDeep('[id^="tda-screenshot-download-btn-container"]');
      if (!btnNative) { 
        console.warn('[CASULO BRIDGE] Botão nativo não encontrado.');
        window.__casulo_snatching = false; 
        return null; 
      }
      btnNative.click();
      return new Promise((resolve) => {
          let attempts = 0;
          const check = setInterval(() => {
              attempts++;
              const res = window.__casulo_caught_url || (window.__casulo_intercepted_blob ? URL.createObjectURL(window.__casulo_intercepted_blob) : null);
              if (res) { clearInterval(check); window.__casulo_snatching = false; resolve(res); }
              if (attempts > 100) { // Aumentado para 10 segundos (v12.33.15)
                clearInterval(check); 
                window.__casulo_snatching = false; 
                console.error('[CASULO BRIDGE] Timeout na captura do snapshot.');
                resolve(null); 
              }
          }, 100);
      });
  };

  const getAngle3DCache = () => { try { return JSON.parse(localStorage.getItem('__casulo_angle3d_cache') || '{}'); } catch(e) { return {}; } };
  const setAngle3DCache = (vid, data) => { 
    if (!vid) return;
    const cache = getAngle3DCache(); 
    cache[vid.toString()] = { image: data.image || cache[vid.toString()]?.image || null, url: data.url || cache[vid.toString()]?.url || window.location.href, last_update: new Date().getTime() };
    localStorage.setItem('__casulo_angle3d_cache', JSON.stringify(cache));
  };

  const syncItemWithAPI = async (vid, pid, image) => {
    try {
      const customer_id = getShopifyCustomerId();
      const browser_id = getBrowserId();
      
      const res = await fetch('/apps/orcamento/orcamento/sync-item', { 
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify({ 
          customer_id: customer_id ? customer_id.toString() : null, 
          browser_id: browser_id,
          variant_id: vid.toString(), 
          product_id: pid ? pid.toString() : null, 
          image: image,
          product_type: 'orcamento'
        }) 
      });
      if (!res.ok) console.warn('[CASULO BRIDGE] Erro na sincronização com API:', res.status);
    } catch (e) {
      console.error('[CASULO BRIDGE] Falha crítica no syncItemWithAPI:', e.message);
    }
  };

  const angle3dEvents = ['Angle3DCustomizerPriceChanged', 'Angle3DBundleSelectedVariantsChanged', 'Angle3DAddToCart', 'Angle3DConfigurationChange'];
  angle3dEvents.forEach(evtName => {
    window.addEventListener(evtName, (e) => {
       let vid = e.detail?.variant_id || e.detail?.id || e.detail?.productId;
       if (vid) setAngle3DCache(vid, { url: window.location.href });
    });
  });

  window.__casulo_processing_click = false;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.tda-customizer-footer-atc-btn') || e.target.closest('.tda-customizer-footer-buy-btn');
    if (btn && !btn.dataset.casuloIntercept && !window.__casulo_processing_click) {
      const viewer = document.querySelector('tda-model-viewer');
      if (viewer) {
          window.__casulo_processing_click = true;
          e.stopImmediatePropagation(); e.preventDefault();

          // --- Casulo B2B: Validação Angle3D (v4.5.0) ---
          const productInfo = document.querySelector('product-info');
          const collections = productInfo ? productInfo.dataset.productCollections : '';
          
          if (window.CasuloCart && window.CasuloCart.Validation) {
            const validation = await window.CasuloCart.Validation.validateAddition(collections);
            if (!validation.valid) {
              const errorWrapper = document.getElementById(`orcamento-error-wrapper-${productInfo?.dataset.section || 'main'}`) || 
                                   document.querySelector('.product-form__error-message-wrapper');
              
              if (errorWrapper) {
                const errorMsg = errorWrapper.querySelector('.product-form__error-message') || errorWrapper;
                errorMsg.textContent = validation.message;
                errorWrapper.style.display = 'block';
                errorWrapper.removeAttribute('hidden');
                errorWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
              } else {
                alert(validation.message);
              }
              window.__casulo_processing_click = false;
              return;
            }
          }

          const originalText = btn.textContent;
          btn.disabled = true; btn.textContent = 'Aguarde...';
          const snapshot = await capturarNativeAngle3D(500);
          
          if (!snapshot) { 
            alert('Aguarde um instante enquanto capturamos sua configuração e tente novamente.');
            btn.disabled = false; 
            btn.textContent = originalText; 
            window.__casulo_processing_click = false; 
            return; 
          }

          const vid = viewer.getAttribute('variant-id') || viewer.dataset.variantId || getShopifyProductId();
          if (vid) { 
            setAngle3DCache(vid, { image: snapshot }); 
            try {
              await syncItemWithAPI(vid, getShopifyProductId(), snapshot); 
            } catch (err) {
              console.error('[CASULO BRIDGE] Erro ao sincronizar imagem antes de adicionar ao carrinho.');
            }
          }
          
          btn.dataset.casuloIntercept = 'true'; 
          btn.disabled = false; 
          btn.textContent = originalText; 
          btn.click();
          setTimeout(() => { delete btn.dataset.casuloIntercept; window.__casulo_processing_click = false; }, 1500);
      } else { btn.dataset.casuloIntercept = 'true'; btn.click(); }
    }
  }, true);

  /**
   * 2. LÓGICA DE CARRINHO (v11 BACKUP)
   */
  const cleanTitle = (t) => t ? t.replace(/\s*\(Bundle\s+[a-zA-Z0-9-]+\)\s*/gi, '').trim() : '';
  const isUserLogged = () => !!getShopifyCustomerId();

  const getDetailedSpecs = (item, index, isCartPage) => {
    let specs = [];
    
    // 1. Fallback JSON
    if (item.properties) {
      Object.entries(item.properties).forEach(([k, v]) => {
        if (!k.startsWith('_') && v) specs.push(`${k}: ${v}`);
      });
    }

    if (isCartPage) {
      try {
        const rows = document.querySelectorAll('.cart-item');
        const vid = (item.variant_id || item.id)?.toString();
        const row = Array.from(rows).find(r => {
          const qInput = r.querySelector('[data-quantity-variant-id]');
          return qInput && qInput.getAttribute('data-quantity-variant-id') === vid;
        }) || rows[index];

        if (row) {
          let domSpecs = [];
          
          // Captura <dl> padrão (DT/DD)
          const dlPairs = row.querySelectorAll('.product-option dt, .product-option dd');
          for (let i = 0; i < dlPairs.length; i += 2) {
            const dt = dlPairs[i]?.textContent?.trim();
            const dd = dlPairs[i+1]?.textContent?.trim();
            if (dt && dd) domSpecs.push(`${dt} ${dd}`);
          }

          // Captura Bundles (TDA Items)
          const merged = row.querySelector('.tda-merged-cart-items');
          if (merged) {
            merged.querySelectorAll('li').forEach(li => {
              // Pega o título ignorando o multiplicador (1 x)
              const titleEl = Array.from(li.querySelectorAll('strong')).find(s => !s.textContent.includes('×') && s.textContent.trim() !== '');
              const title = titleEl ? titleEl.textContent.trim() : '';

              // CORRECAO: os <li> sem <strong> sao as propriedades do produto
              // principal (ex.: "Cor Tampo : 25 Lanarca"), desenhadas como texto
              // simples pelo snippet do Angle3D. Antes eram descartadas.
              if (!title) {
                if (li.querySelector('li')) return; // ignora <li> que contem outros <li>
                const plain = (li.textContent || '').replace(/\s+/g, ' ').trim();
                if (plain && plain.includes(':')) domSpecs.push(plain);
                return;
              }

              const optionEl = li.querySelector('.product-details__item--variant-option');
              const option = optionEl ? optionEl.textContent.trim().replace(/\s+/g, ' ') : '';
              
              // Pega apenas o div que contém "Label:" sem pegar os pais
              const labelEl = Array.from(li.querySelectorAll('div')).find(div => div.textContent.includes('Label:') && !div.querySelector('div'));
              const label = labelEl ? labelEl.textContent.replace('Label:', '').trim() : '';
              
              let entry = title;
              if (option) entry += ` - ${option}`;
              if (label) entry += ` (${label})`;
              
              if (entry) domSpecs.push(entry.replace(/\s+/g, ' '));
            });
          }
          
          // CORRECAO: acrescenta em vez de substituir, sem duplicar
          if (domSpecs.length > 0) {
            domSpecs.forEach(entry => {
              const clean = String(entry).replace(/\s+/g, ' ').trim();
              if (!clean) return;
              const norm = clean.toLowerCase();
              if (!specs.some(x => String(x).replace(/\s+/g, ' ').trim().toLowerCase() === norm)) {
                specs.push(clean);
              }
            });
          }
        }
      } catch (e) {
        console.warn('[CASULO BRIDGE] Falha ao ler detalhes do carrinho na tela:', e);
      }
    }
    return specs.filter(s => !!s).join('\n');
  };

  const hijackCart = async () => {
    if (window.location.pathname.includes('/cart')) {
      const tags = (window.__casulo_customer_tags || []);
      console.log('🔍 [CASULO DEBUG] Tags do Cliente:', tags);
      // alert('DEBUG: Suas tags atuais são: ' + tags.join(', '));

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      
      let hasAngle3D = false;
      let hasShopify = false;
      
      console.log('📦 [CASULO DEBUG]: Iniciando verificação de detalhes do carrinho...');
      cart.items.forEach((item, index) => {
        const specs = getDetailedSpecs(item, index, true);
        console.log(`🔹 Produto [${index}]: ${item.title}`);
        console.log(`   ID: ${item.variant_id} | SKU: ${item.sku}`);
        console.log(`   Detalhes Extraídos (DOM/Properties):\n${specs || '⚠️ Nenhuma especificação encontrada.'}`);
        console.log(`   [DEBUG COMPLETO - OBJETO DO ITEM]:`, item);
        if (item.properties && Object.keys(item.properties).length > 0) {
            console.log(`   [DEBUG COMPLETO - PROPRIEDADES (Line Items)] do Produto ${item.title}:`, item.properties);
        }

        try {
            const rowScripts = document.querySelectorAll(`.casulo-product-metafields[data-vid="${item.variant_id}"]`);
            // Pode haver múltiplos items da mesma variante no carrinho (improvável de causar bug, mas previnimos)
            if (rowScripts.length > 0) {
                const metaJSON = JSON.parse(rowScripts[0].innerHTML);
                console.log(`   🟢 [METACAMPOS DO PRODUTO (Somente Custom)] do Produto ${item.title}:`, metaJSON);
            } else {
                console.log(`   🔴 [METACAMPOS DO PRODUTO]: Não renderizados pelo Liquid. Talvez esteja vazio ou falhou.`);
            }
        } catch(e) {
            console.warn(`   🔴 [METACAMPOS ERROR] Falha ao extrair metacampos:`, e);
        }
        
        let isAngle = !!(item.properties && Object.keys(item.properties).some(k => !k.startsWith('_'))) || item.title.includes('(Bundle') || (item.properties && item.properties._product_type === 'orcamento');
        if (isAngle) hasAngle3D = true; else hasShopify = true;
      });
      console.log('--------------------------------------------------');

      // SE FOR MISTO OU APENAS ANGLE3D, PRECISAMOS INTERVIR
      if (hasAngle3D) {
        const isLogged = isUserLogged();
        const checkoutBtns = document.querySelectorAll('[name="checkout"], .cart__checkout-button');
        checkoutBtns.forEach(btn => {
          if (!btn.dataset.casuloIntercepted) {
             // Se for misto, o botão já é o de 'Limpar' via Liquid, mas se o JS chegar aqui:
             if (hasShopify) {
                btn.addEventListener('click', (e) => { e.preventDefault(); alert('Carrinho Misto Detectado: Por favor, limpe o carrinho para prosseguir com pedidos separados.'); });
                return;
             }
             
             if (!isLogged) {
                btn.dataset.casuloIntercepted = 'true';
                btn.type = 'button';
                btn.addEventListener('click', (e) => { e.preventDefault(); e.stopImmediatePropagation(); openLeadModal(); });
                btn.textContent = 'FINALIZAR ORÇAMENTO';
                btn.style.setProperty('background', '#000000', 'important');
                btn.style.setProperty('color', '#fff', 'important');
             }
          }
        });
      }

      // 6. BLOCO B2B PROFISSIONAL (CONSULTOR / ESPECIFICADOR) - v12.45.0
      // Esta regra tem prioridade para usuários logados com as tags corretas
      if (isProfessional()) {
          console.log('[CASULO B2B] Modo Profissional Ativo: Interceptando checkout para orçamento.');
          const selectors = [
            'button[name="checkout"]',
            'input[name="checkout"]',
            '.cart__checkout-button',
            '#checkout',
            'a[href*="/checkout"]',
            '.pf-checkout-btn',
            '.shopify-payment-button button',
            '.checkout-button',
            '#btn-solicitar-orcamento-cart'
          ];
          const checkoutBtns = document.querySelectorAll(selectors.join(', '));
          
          checkoutBtns.forEach(btn => {
              if (!btn.dataset.proIntercepted) {
                  btn.dataset.proIntercepted = 'true';
                  btn.addEventListener('click', (e) => {
                      console.log('[CASULO B2B] Clique interceptado: Abrindo modal de vínculo.');
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation();
                      
                      const modal = document.getElementById('casulo-pro-link-modal');
                      if (modal) {
                          modal.style.display = 'flex';
                          if (window.showProClientDropdown) window.showProClientDropdown();
                      }
                  }, true);
              }
          });
      }

      // NOVO: Bloqueio de Checkout para Acesso Temporário (v12.31.30)
      const customerTags = (window.__casulo_customer_tags || []).map(t => t.toLowerCase());
      const isTemporario = customerTags.includes('finalizar-cadastro');
      if (isTemporario) {
          console.log('[CASULO DEBUG] Bloqueio de Checkout Ativo: Usuário Temporário.');
          const checkoutBtns = document.querySelectorAll('[name="checkout"], .cart__checkout-button');
          checkoutBtns.forEach(btn => {
              btn.addEventListener('click', (e) => {
                  console.log('[CASULO DEBUG] Clique interceptado: Pendência de cadastro.');
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  if (window.openCasuloFinalizeModal) window.openCasuloFinalizeModal();
              }, true); // Use capture: true para garantir a prioridade
          });
      }
    }
  };

  const deepSanitize = async (root) => {
    if (!root) return;
    
    const isCart = window.location.pathname.includes('/cart');
    const isLogged = !!getShopifyCustomerId();
    const customerTags = (window.__casulo_customer_tags || []).map(t => t.toLowerCase());
    const hasSpecialAccess = customerTags.includes('aprovado') || customerTags.includes('acesso_temporario');
    
    let shouldHidePrices = !hasSpecialAccess;
    let isPureShopifyCart = false;

    // v12.31.25: Detector de Fluxo Inteligente (Respeita Matriz de Acesso)
    const flowDetector = document.querySelector('.casulo-flow-detector');
    const flowType = flowDetector ? flowDetector.dataset.casuloFlow : 'unknown';
    const isRestricted = flowDetector ? flowDetector.dataset.casuloRestricted === 'true' : false;
    const isShopifyFlow = flowType === 'shopify';

    if (isCart) {
       const cartRes = await fetch('/cart.js');
       const cart = await cartRes.json();
       const hasAngle3D = cart.items.some(item => (item.properties && Object.keys(item.properties).some(k => !k.startsWith('_'))) || item.title.includes('(Bundle') || (item.properties && item.properties._product_type === 'orcamento'));
       
       // Se o carrinho só tiver itens de Loja/Pronta-entrega, libera para todos
       if (!hasAngle3D) {
         shouldHidePrices = false;
         isPureShopifyCart = true;
       }
    } else {
       // Na página do produto, libera se for Loja ou se for Restritos (para logados)
       if (isShopifyFlow || (isRestricted && isLogged)) {
          shouldHidePrices = false;
       }
    }

    // [CASULO AUDIT] Verificação de sanidade
    if (root === document) {
      console.info(`[CASULO AUDIT] Flow: ${flowType} | PureCart: ${isPureShopifyCart} | Hidden: ${shouldHidePrices}`);
    }

    const priceSelectors = ['.cart-item__price', '.cart-item__totals', '.totals__subtotal-value', '.product__price', '.tda-customizer-variant-price', '.pf-product-price', '.price-item', '.totals__subtotal', '.price', '.price--large', '.cart-item__price-wrapper'];

    if (shouldHidePrices) {
      priceSelectors.forEach(sel => {
        const els = root.querySelectorAll ? root.querySelectorAll(sel) : [];
        els.forEach(el => { 
          // v12.32.1: Exceção para produtos com tag "loja" ou "pronta-entrega"
          const isPublic = el.classList.contains('casulo-public-price') || el.closest('.casulo-public-price');
          
          if (!isPublic && (el.textContent.includes('R$') || el.classList.contains('price') || el.classList.contains('cart-item__price-wrapper'))) {
            el.style.setProperty('display', 'none', 'important'); 
          }
        });
      });

      const btns = root.querySelectorAll ? root.querySelectorAll('.tda-customizer-footer-atc-btn, .tda-customizer-footer-buy-btn, .pf-product-atc') : [];
      btns.forEach(btn => { if (!btn.textContent.toUpperCase().includes('ORÇAMENTO')) { btn.textContent = 'FINALIZAR ORÇAMENTO'; btn.style.setProperty('background', '#000000', 'important'); btn.style.setProperty('color', '#fff', 'important'); } });
    } else if (isShopifyFlow || isPureShopifyCart) {
      // FORCE SHOW: Se for Shopify (Produto ou Carrinho Puro), garante que nada esconda o preço
      priceSelectors.forEach(sel => {
        const els = root.querySelectorAll ? root.querySelectorAll(sel) : [];
        els.forEach(el => { 
          // Se estiver escondido por CSS, força a exibição
          const style = window.getComputedStyle(el);
          if (style.display === 'none' || el.style.display === 'none') {
            el.style.setProperty('display', 'block', 'important'); 
            el.style.setProperty('visibility', 'visible', 'important');
            el.style.setProperty('opacity', '1', 'important');
            console.log('[CASULO AUDIT] Force-Showing Price Element:', sel);
          }
        });
      });
    }

    hijackCart();

    const walker = document.createTreeWalker(root instanceof ShadowRoot ? root : root, NodeFilter.SHOW_ELEMENT, null, false);
    let curr = walker.currentNode;
    while (curr) { if (curr.shadowRoot) deepSanitize(curr.shadowRoot); if (curr.tagName === 'IFRAME') { try { deepSanitize(curr.contentDocument || curr.contentWindow.document); } catch(e) {} } curr = walker.nextNode(); }
  };

  let casuloSanitize = () => { try { deepSanitize(document); } catch (e) {} };

  const applyMask = (input, maskType) => {
    input.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      if (maskType === 'whatsapp') {
        if (value.length > 11) value = value.slice(0, 11);
        if (value.length > 10) {
          value = value.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
        } else if (value.length > 6) {
          value = value.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
        } else if (value.length > 2) {
          value = value.replace(/^(\d{2})(\d{0,5}).*/, '($1) $2');
        } else {
          value = value.replace(/^(\d*)/, '($1');
        }
      } else if (maskType === 'cep') {
        if (value.length > 8) value = value.slice(0, 8);
        value = value.replace(/^(\d{5})(\d{0,3}).*/, '$1-$2');
      } else if (maskType === 'cnpj') {
        if (value.length > 14) value = value.slice(0, 14);
        value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5');
      }
      e.target.value = value;
    });
  };

  const initMasks = () => {
    const ws = document.getElementById('lead-whatsapp');
    const cp = document.getElementById('lead-cep');
    const cj = document.getElementById('lead-cnpj');
    if (ws) applyMask(ws, 'whatsapp');
    if (cp) applyMask(cp, 'cep');
    if (cj) applyMask(cj, 'cnpj');
  };

  const openLeadModal = async () => {
    const modal = document.getElementById('casulo-lead-modal');
    const listContainer = document.getElementById('casulo-items-list-container');
    if (modal) {
      modal.style.display = 'flex';
      initMasks();
      if (listContainer) {
        listContainer.innerHTML = '<div style="color: #666; font-style: italic;">Carregando sua lista...</div>';
        const isCartPage = window.location.pathname.includes('/cart');
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        listContainer.innerHTML = cart.items.map((item, index) => `
            <div style="margin-bottom: 1rem; padding-bottom: 0.5rem; border-bottom: 1px dashed #eee;">
                <div style="font-weight: bold; font-size: 1.1rem; color: #333;">${cleanTitle(item.title)}</div>
                <div style="color: #666; font-size: 0.95rem;">${getDetailedSpecs(item, index, isCartPage) || 'Especificações padrão'}</div>
                <div style="font-size: 0.85rem; color: #888;">Quantidade: ${item.quantity}</div>
            </div>
        `).join('');
      }
    }
  };
  window.openLeadModal = openLeadModal;
  

  window.openCasuloFinalizeModal = () => {
    const modal = document.getElementById('casulo-finalize-registration-modal');
    if (modal) {
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        console.log('[CASULO DEBUG] Modal Finalização de Cadastro Aberto.');
    }
  };

  window.closeCasuloFinalizeModal = () => {
    const modal = document.getElementById('casulo-finalize-registration-modal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
    }
  };

  const processarEnvioOrcamento = async (leadData = null, btn = null) => {
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando...'; }
      try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const cache = getAngle3DCache();
          const base64Map = {};
          const isCartPage = window.location.pathname.includes('/cart');

          const enrichedItems = cart.items.map((item, idx) => {
              const vid = item.variant_id.toString();
              const img = cache[vid]?.image || item.image;
              const specs = getDetailedSpecs(item, idx, isCartPage);
              
              let especificacao_generica = null;
              try {
                  const scriptElems = document.querySelectorAll(`.casulo-product-metafields[data-vid="${vid}"]`);
                  if (scriptElems.length > 0) {
                      const metaInfo = JSON.parse(scriptElems[0].innerHTML);
                      if (metaInfo.especificacao_generica) {
                          especificacao_generica = metaInfo.especificacao_generica;
                      }
                  }
              } catch(e) {}

              if (img && img.startsWith('data:image')) { base64Map[idx] = img; return { title: cleanTitle(item.title), variant_id: vid, product_id: item.product_id.toString(), quantity: item.quantity, technical_specification: specs, especificacao_generica: especificacao_generica, custom_image: '__pending__', price: (item.price/100).toFixed(2) }; }
              return { title: cleanTitle(item.title), variant_id: vid, product_id: item.product_id.toString(), quantity: item.quantity, technical_specification: specs, especificacao_generica: especificacao_generica, custom_image: img, price: (item.price/100).toFixed(2) };
          });

          const bodyPayload = { 
            customer_id: getShopifyCustomerId(), 
            browser_id: getBrowserId(), 
            lead: leadData, 
            items: enrichedItems 
          };

          // Se não for fluxo B2B profissional, envia os metadados do cliente logado normalmente
          if (!window.__casulo_pro_flow_data) {
            bodyPayload.customer_metadata = window.CustomerData;
          }

          // Injetar dados de fluxo profissional se existirem (v12.40.1)
          if (window.__casulo_pro_flow_data) {
            console.log('[CASULO DEBUG]: Mesclando dados do fluxo B2B Profissional...');
            Object.assign(bodyPayload, window.__casulo_pro_flow_data);
          }

          const response = await fetch('/apps/orcamento/orcamento', { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify(bodyPayload) 
          });

          console.log(`[CASULO DEBUG]: Resposta do Orçamento: Status ${response.status}`);

          if (response.ok) {
              const result = await response.json();
              console.log('[CASULO DEBUG]: Orçamento criado com sucesso!', result);
              
              if (Object.keys(base64Map).length > 0) { 
                console.log('[CASULO DEBUG]: Enviando snapshots...');
                await fetch(`/apps/orcamento/orcamento/${result.id}/snapshot`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ base64Map }) }); 
              }
              
              await fetch('/cart/clear.js', { method: 'POST' });
              localStorage.removeItem('__casulo_angle3d_cache');
                            if (window.abrirPopupSolicitacaoEnviada) {
                window.abrirPopupSolicitacaoEnviada();
              } else {
                window.location.href = '/collections/produtos-customizaveis';
              }
          } else {
              const errData = await response.json().catch(() => ({}));
              console.error('[CASULO ERROR]: Falha ao criar orçamento:', errData);
              alert('Erro ao processar orçamento. Por favor, tente novamente.');
          }
      } catch (e) { 
          console.error('[CASULO EXCEPTION]:', e);
          if (btn) { btn.disabled = false; btn.textContent = 'Tentar Novamente'; } 
      }
  };
  window.processarEnvioOrcamento = processarEnvioOrcamento;
    // === POPUP DE CONFIRMAÇÃO DE SOLICITAÇÃO (Casulo) ===
  window.abrirPopupSolicitacaoEnviada = function () {
    var destino = '/collections/produtos-customizaveis';

    var fundo = document.createElement('div');
    fundo.setAttribute('id', 'casulo-popup-solicitacao');
    fundo.style.cssText =
      'position:fixed;inset:0;background:rgba(0,0,0,.55);' +
      'display:flex;align-items:center;justify-content:center;' +
      'z-index:99999;padding:20px;';

    var caixa = document.createElement('div');
    caixa.style.cssText =
      'background:#fff;max-width:440px;width:100%;padding:40px 32px;' +
      'text-align:center;font-family:Assistant,sans-serif;color:#2B2B2B;';

    var titulo = document.createElement('h2');
    titulo.textContent = 'Solicitação enviada';
    titulo.style.cssText =
      'font-size:22px;font-weight:700;margin:0 0 20px;color:#2B2B2B;';

    var p1 = document.createElement('p');
    p1.textContent =
      'Obrigado. Sua solicitação de orçamento foi registrada e será ' +
      'analisada pela nossa equipe comercial.';
    p1.style.cssText =
      'font-size:15px;line-height:1.6;margin:0 0 16px;color:#5F5F5F;';

    var p2 = document.createElement('p');
    p2.textContent =
      'Em breve um consultor entrará em contato pelo e-mail cadastrado ' +
      'para apresentar a proposta e esclarecer as condições.';
    p2.style.cssText =
      'font-size:15px;line-height:1.6;margin:0 0 28px;color:#5F5F5F;';

    var botao = document.createElement('button');
    botao.type = 'button';
    botao.textContent = 'CONTINUAR';
    botao.style.cssText =
      'background:#556B57;color:#fff;border:none;cursor:pointer;' +
      'padding:14px 40px;font-size:14px;letter-spacing:.05em;' +
      'font-family:Assistant,sans-serif;';

    botao.addEventListener('click', function () {
      window.location.href = destino;
    });

    caixa.appendChild(titulo);
    caixa.appendChild(p1);
    caixa.appendChild(p2);
    caixa.appendChild(botao);
    fundo.appendChild(caixa);
    document.body.appendChild(fundo);
  };
  // === FIM DO POPUP ===

  document.addEventListener('submit', (e) => {
      if (e.target.id === 'casulo-lead-form') { 
        e.preventDefault(); 
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData);
        
        // Validação extra pro CNPJ se for PJ
        if (data.tipo_pessoa === 'PJ' && (!data.cnpj || data.cnpj.replace(/\D/g, '').length < 14)) {
          alert('Por favor, preencha um CNPJ válido.');
          return;
        }

        processarEnvioOrcamento(data, e.target.querySelector('button[type="submit"]')); 
      }
  });

  /**
   * 4. MONITORAMENTO DE MUDANÇAS (AJAX SAFE)
   * Garante que o bloqueador de carrinho misto suma ao remover produtos sem F5.
   */
  const monitorarCarrinho = () => {
    const cartContainer = document.querySelector('cart-items, #main-cart-items, .cart-items');
    if (!cartContainer || window.__casulo_monitor_active) return;

    console.log('[CASULO MONITOR] Vigiando mudanças no carrinho...');
    window.__casulo_monitor_active = true;

    const observer = new MutationObserver(async (mutations) => {
      // Evita loops infinitos se o próprio script mudar algo
      if (window.__casulo_evaluating) return;
      
      console.log('[CASULO MONITOR] Mudança detectada. Re-avaliando regras...');
      window.__casulo_evaluating = true;
      
      // Re-executa a sanitização e o hijack
      await casuloSanitize();
      
      // Se o alerta ainda estiver lá mas o motivo (mix) sumir, o ideal é forçar reload 
      // para restaurar os botões de checkout nativos que o Liquid escondeu
      const res = await fetch('/cart.js');
      const cart = await res.json();
      
      let hasBudget = false;
      let hasLoja = false;

      // Pegamos as coleções via API ou DOM (aqui usamos a lógica de itens do carrinho)
      const itemElements = document.querySelectorAll('.cart-item');
      if (itemElements.length !== cart.items.length && cart.items.length > 0) {
         // Se houve remoção, o reload é o caminho mais seguro para restaurar o estado Liquid
         window.location.reload();
         return;
      }

      window.__casulo_evaluating = false;
    });

    observer.observe(cartContainer, { childList: true, subtree: true });
  };

  /**
   * 5. AUTO-PREENCHIMENTO DE FORMULÁRIOS (v12.31.50)
   * Detecta o app Shopify Forms e preenche Nome/E-mail se logado.
   */
  /**
   * 5. AUTO-PREENCHIMENTO DE FORMULÁRIOS (v12.31.55)
   * Detecta o app Shopify Forms e preenche Nome/E-mail se logado.
   * Usa o hack de Native Setter para contornar o estado do React.
   */
  const autoFillShopifyForms = () => {
    const isCadastroPage = window.location.pathname.includes('/pages/finalizar-cadastro');
    if (!isCadastroPage || !window.CustomerData || !window.CustomerData.id) return;

    console.log('[CASULO DEBUG] Página de cadastro detectada. Iniciando auto-preenchimento...');

    const setReactValue = (el, val) => {
        if (!el) return;
        const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;
        const finalSetter = el.tagName === 'TEXTAREA' ? nativeSetter : setter;
        
        if (finalSetter && finalSetter !== Object.getOwnPropertyDescriptor(el, 'value')?.set) {
            finalSetter.call(el, val);
        } else {
            el.value = val;
        }
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
        el.dispatchEvent(new Event('blur', { bubbles: true }));
    };

    let attempts = 0;
    const maxAttempts = 20;

    const fillInterval = setInterval(() => {
        attempts++;
        if (attempts > maxAttempts) {
            clearInterval(fillInterval);
            return;
        }

        const emailInput = findDeep('input[type="email"]');
        const nameInput = findDeep('input[placeholder*="Nome"], input[name*="name"], input[placeholder*="Completo"]');

        if (emailInput && (!emailInput.value || emailInput.value === '')) {
            setReactValue(emailInput, window.CustomerData.email || '');
            console.log('[CASULO DEBUG] E-mail injetado via Native Setter.');
        }

        if (nameInput && (!nameInput.value || nameInput.value === '')) {
            setReactValue(nameInput, window.CustomerData.name || '');
            console.log('[CASULO DEBUG] Nome injetado via Native Setter.');
        }

        // Verificação de persistência
        if (emailInput?.value && nameInput?.value) {
            console.log('[CASULO DEBUG] Campos preenchidos e persistentes.');
            // Esperamos mais 2 segundos para garantir que o app não limpe
            if (attempts > 5) clearInterval(fillInterval);
        }
    }, 1000);
  };

  const checkSentStatus = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('status') === 'sent') {
      const modal = document.getElementById('casulo-sent-success-modal');
      if (modal) {
        modal.style.display = 'flex';
        // Limpar a URL para não abrir o modal de novo no refresh
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
  };

  /**
   * 6. SISTEMA PROFISSIONAL (CONSULTOR / ESPECIFICADOR) - v12.40.0
   */
  const isProfessional = () => {
    const tags = (window.__casulo_customer_tags || []).map(t => t.toLowerCase().trim());
    console.log('[DEBUG B2B]: Tags encontradas:', tags);
    const result = tags.includes('consultor') || tags.includes('especificador');
    console.log('[DEBUG B2B]: É profissional?', result);
    return result;
  };

  const getProRole = () => {
    const tags = (window.__casulo_customer_tags || []).map(t => t.toLowerCase());
    if (tags.includes('consultor')) return 'Consultor';
    if (tags.includes('especificador')) return 'Especificador';
    return null;
  };

  window.closeProModal = () => {
    const modal = document.getElementById('casulo-pro-link-modal');
    if (modal) modal.style.display = 'none';
  };

  window.showProClientDropdown = async () => {
    document.getElementById('pro-client-form-el').style.display = 'none';
    const container = document.getElementById('pro-client-dropdown-container');
    container.style.display = 'block';
    
    const select = document.getElementById('pro-client-select');
    select.innerHTML = '<option value="">Carregando...</option>';
    
    try {
      const res = await fetch('/apps/orcamento/pro/customers');
      const clients = await res.json();
      
      select.innerHTML = '<option value="">Selecione um cliente...</option>';
      clients.forEach(c => {
        const option = document.createElement('option');
        option.value = c.child_id;
        option.textContent = `${c.child_name} (${c.child_email})`;
        select.appendChild(option);
      });
      
      select.onchange = () => {
        document.getElementById('btn-next-step').disabled = !select.value;
      };
    } catch (e) {
      select.innerHTML = '<option value="">Erro ao carregar clientes</option>';
    }
  };

  window.showProClientForm = () => {
    document.getElementById('pro-client-dropdown-container').style.display = 'none';
    document.getElementById('pro-client-form-el').style.display = 'block';
    
    const phoneInput = document.getElementById('pro-client-phone-mask-pro');
    if (phoneInput && !phoneInput.dataset.masked) {
      applyMask(phoneInput, 'whatsapp');
      phoneInput.dataset.masked = 'true';
    }
  };

  window.goToProConnectionStep = async () => {
    const clientId = document.getElementById('pro-client-select').value;
    if (!clientId) {
      alert('Por favor, selecione ou cadastre um cliente primeiro.');
      return;
    }
    
    const role = getProRole();
    const otherRole = role === 'Consultor' ? 'Especificador' : 'Consultor';
    
    document.getElementById('pro-step-client').style.display = 'none';
    const step2 = document.getElementById('pro-step-connection');
    step2.style.display = 'block';
    
    document.getElementById('pro-connection-label').textContent = `Vincular a um ${otherRole}?`;
    
    const select = document.getElementById('pro-connection-select');
    select.innerHTML = '<option value="">Nenhum (Opcional)</option>';
    
    try {
      const proId = getShopifyCustomerId();
      const email = window.__casulo_customer_email;
      const res = await fetch(`/apps/orcamento/pro/connections?customer_email=${encodeURIComponent(email)}`);
      const data = await res.json();
      
      data.connections.forEach(conn => {
        const option = document.createElement('option');
        const otherId = conn.parent_id === proId.toString() ? conn.child_id : conn.parent_id;
        option.value = otherId;
        option.textContent = conn.child_name || 'Profissional Vinculado';
        select.appendChild(option);
      });
    } catch (e) {}
  };

  window.backToProClientStep = () => {
    document.getElementById('pro-step-connection').style.display = 'none';
    document.getElementById('pro-step-client').style.display = 'block';
  };

  window.finalizeProProposal = async () => {
    const btn = document.getElementById('btn-finalize-pro');
    const clientId = document.getElementById('pro-client-select').value;
    const connectionId = document.getElementById('pro-connection-select').value;
    const role = getProRole();
    
    if (!clientId) {
      alert('Por favor, selecione ou crie um cliente.');
      return;
    }

    const connectionSelect = document.getElementById('pro-connection-select');
    const connectionName = connectionSelect.options[connectionSelect.selectedIndex].text;
    const myName = window.__casulo_customer_name || 'Profissional Logado';

    const proData = {
      customer_id: clientId,
      consultor_id: role === 'Consultor' ? getShopifyCustomerId().toString() : (connectionId || null),
      consultor_name: role === 'Consultor' ? myName : (connectionId ? connectionName : null),
      especificador_id: role === 'Especificador' ? getShopifyCustomerId().toString() : (connectionId || null),
      especificador_name: role === 'Especificador' ? myName : (connectionId ? connectionName : null)
    };
    
    window.__casulo_pro_flow_data = proData;
    
    btn.disabled = true;
    btn.textContent = 'Enviando...';
    
    await processarEnvioOrcamento(null, btn);
  };

  // Interceptador para formulário de criação de cliente
  document.addEventListener('submit', async (e) => {
    if (e.target.id === 'pro-client-form-el') {
      e.preventDefault();
      const btn = e.target.querySelector('button');
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Criando cliente...';
      
      const formData = new FormData(e.target);
      const data = Object.fromEntries(formData);
      
      try {
        const res = await fetch('/apps/orcamento/pro/customer/create', { // ENDPOINT DE CADASTRO
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });
        
        console.log(`[CASULO DEBUG]: Resposta Criação Cliente: Status ${res.status}`);
        
        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          console.error('[CASULO ERROR]: Falha ao criar cliente:', errData);
          throw new Error(errData.error || 'Erro ao criar cliente');
        }
        
        const result = await res.json();
        const select = document.getElementById('pro-client-select');
        const cleanId = result.customer.id.replace('gid://shopify/Customer/', '');
        
        select.innerHTML = `<option value="${cleanId}" selected>${result.customer.firstName} ${result.customer.lastName}</option>`;
        
        goToProConnectionStep();
      } catch (err) {
        alert(err.message);
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  });

  casuloSanitize();
  monitorarCarrinho();
  autoFillShopifyForms();
  checkSentStatus();
  setInterval(casuloSanitize, 500);
  
  // === HOVER DO BOTÃO DE ORÇAMENTO (Casulo) ===
  (function () {
    var estilo = document.createElement('style');
    estilo.textContent =
      '.tda-customizer-footer-atc-btn,' +
      '.tda-customizer-footer-buy-btn {' +
      '  transition: opacity .2s ease, transform .1s ease;' +
      '}' +
      '.tda-customizer-footer-atc-btn:hover,' +
      '.tda-customizer-footer-buy-btn:hover {' +
      '  opacity: .85 !important;' +
      '  cursor: pointer !important;' +
      '}' +
      '.tda-customizer-footer-atc-btn:active,' +
      '.tda-customizer-footer-buy-btn:active {' +
      '  transform: scale(.98);' +
      '}';
    document.head.appendChild(estilo);
  })();
  // === FIM DO HOVER ===
})();
